import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Icon, Modal} from "antd"

class ItemSideDefault extends Component {
    state = {
        modal: false,
    }

    _showModal = () => {
        this.setState({
            modal: true,
        })
    }

    _hideModal = () => {
        this.setState({
            modal: false,
        })
    }

    render() {
        const {preview_image} = this.props
        const {modal} = this.state

        return (
            <div className='ItemSideDefault border rounded bg-white'>
                {
                    preview_image &&
                    <div className="Preview position-relative bg-light">
                        <img src={preview_image} alt="Preview" onClick={this._showModal}/>
                        <div className='Actions position-absolute'>
                            {
                                preview_image &&
                                <>
                                    <div className='Icon'>
                                        <Icon type="eye" onClick={this._showModal}/>

                                        <Modal visible={modal} closable={false} centered={true} footer={null} width={1000}
                                               onCancel={this._hideModal}>
                                            <img src={preview_image} alt='full' className='d-block m-auto'/>
                                        </Modal>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                }
            </div>
        )
    }
}

ItemSideDefault.defaultProps = {
    preview_image: '',
}

ItemSideDefault.propTypes = {
    preview_image: PropTypes.string,
}

export default ItemSideDefault
